import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "appg-progress-body"
};
const _hoisted_2 = {
  class: "barWrapper"
};
const _hoisted_3 = {
  class: "appg-progress percentage"
};
import Modal from '@/templates/argon-core/Modal.vue';
import { computed } from 'vue';
import { MAIN_COLOR } from '@/common/constants/ConstCode';
import { useLayoutStore } from '@/store/modules/layout';
export default {
  __name: 'AppgProgressBar',
  setup(__props) {
    const layoutStore = useLayoutStore();
    const progress = layoutStore.progress;
    const isShow = layoutStore.isProgressBar;
    const bar = computed(() => `background: linear-gradient(90deg,  ${MAIN_COLOR} ${progress.value}%,  #eeeeee ${progress.value}%);`);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Modal, {
        show: _unref(isShow),
        size: 'md',
        "show-close": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: "appg-progress bar",
          style: _normalizeStyle(bar.value)
        }, null, 4), _createElementVNode("h6", _hoisted_3, _toDisplayString(`${_unref(progress)}%`), 1)])])]),
        _: 1
      }, 8, ["show"]);
    };
  }
};